export const DG_Format_Money = (value) => {
    if(typeof value === 'number'){
        value = `${value}`;
    }
    const regex = /^\d+\.?\d{1,2}/;
    const valueExec = regex.exec(value)?.[0] || value;
    return valueExec?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}


export const formatCurrency = (num,isNotReplace) => {
    if(isNotReplace){ // dung cho form
        if(typeof num !== 'string'){
            num = String(num)
        }    }
    else { // dung cho map view
        if(typeof num !== 'string'){
            num = String(num)?.replace(".",",")
        }
        else {
            num = num?.replace(".",",")
        }
    }
    const isNegative = num.startsWith("-");
    const cleanNum = isNegative ? num?.slice(1) : num;

    const parts = cleanNum.split(",");
    const integerPart = parts[0].replace(/\D/g, "");
    let decimalPart = parts[1] || "";

    const checkDecimal = typeof decimalPart === 'string' && decimalPart?.length > 2
    if(checkDecimal){
        decimalPart = decimalPart.substring(0,2)
    }
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return (
        (isNegative ? "-" : "") +
        (decimalPart || num.includes(",")
            ? `${formattedInteger},${decimalPart?.replace(/\D/g, "")}`
            : formattedInteger)
    );
};

export const unFormatCurrency = (formattedNum) => {

    if (!formattedNum) return 0;

    const strNumber = String(formattedNum)

    const isNegative = strNumber?.startsWith("-");
    const cleanNum = isNegative ? strNumber?.slice(1) : strNumber;

    const normalizedNum = cleanNum?.replace(/\./g, "")?.replace(",", ".");

    return isNegative ? -parseFloat(normalizedNum) : parseFloat(normalizedNum);
};


export const formatResult = (number, isMoney , isTypeNumber) => {
    if(number === null || number === undefined || isNaN(number)){
        return number
    }

    if(isMoney){
        // đinh dạng tiền tệ : x,xxx.xx
       return  new Intl.NumberFormat().format(number)
    }

    else // dạng số
     return formatCurrency(number);
}

export function getTwoDecimalDigits(number) {
    const decimalPart = number?.toString()?.split('.')[1];
    if (decimalPart) {
        return parseFloat(`${Math.floor(number)}.${decimalPart?.slice(0, 2)}`);
    } else {
        const roundedNumber = Math.round(number * 100) / 100;
        return  roundedNumber?.toLocaleString('vi-VN');
    }
}


export  function to2Floor(swappedString) {

    let commaIndex = swappedString?.indexOf(',');

    if (commaIndex !== -1 && commaIndex < swappedString.length - 2) {
        swappedString = swappedString?.substring(0, commaIndex + 3);
    }
    return swappedString;
}